import React, { useRef, useEffect, useState } from "react";
import {
  RegisterWrapper,
  LoginInputWrapper,
  LoginInput,
  ForgetLink
} from "../UI/register";
import Pic from "../../assets/image/send-message.png";
import { css } from "styled-components/macro";
import { Loading, Title } from "../UI/general";
import fetchModule from "../../utils/fetchingData";
import API from "../../configs/API";
import lstool from "../../utils/localStorage";
import { toast } from "react-toastify";
import { createSendForm } from "../../utils/form";
function ForgetPass(props) {
  let Input = useRef();
  let [state, change] = useState({
    loading: false,
    number: "",
    shouldLogin: false
  });
  const changeInput = e => {
    let val = e.target.value;
    change({ ...state, number: val });
  };
  const submit = async () => {
    change({ ...state, loading: true });

    try {
      let response = await fetchModule.post(
        "",
        createSendForm(
          { type: API.forgetPass, mobilenumber: `09${state.number}` },
          false,
          "multiPart"
        )
      );
      if (response === "true") {
        toast.success("پیامکی حاوی رمز عبور برای شما ارسال شد");
        props.history.push("/login");
      } else {
        toast.warn("این شماره در سیستم وجود ندارد");
      }
    } catch (error) {
      toast.error("مشکلی پیش آمده.دوباره تلاش کنید");
    } finally {
      change(prev => ({ ...prev, loading: false }));
    }
  };
  useEffect(() => {
    Input.current.focus();
  }, []);
  useEffect(() => {
    if (state.number.length === 9) {
      change({ ...state, number: state.number });
      submit();
    }
  }, [state.number]);
  return (
    <>
      {state.loading ? <Loading /> : null}
      <RegisterWrapper>
        <div>
          <img
            css={css`
              max-height: 200px;
            `}
            src={Pic}
          ></img>
        </div>
        <div>
          <Title>شماره تلفن خود را وارد کنید</Title>
          <LoginInputWrapper className="phoneInputWrapper">
            <span>09</span>
            <LoginInput
              ref={Input}
              onChange={changeInput}
              disabled={state.loading}
              value={state.number}
              type="tel"
            ></LoginInput>
          </LoginInputWrapper>
        </div>
      </RegisterWrapper>
    </>
  );
}
export default ForgetPass;
